import axios, { type AxiosResponse } from 'axios';
import { type HotelReviewsResult } from "./types";

export default async function getHotelReviews(params: { limit: number, hotelId: number, page: number }): Promise<HotelReviewsResult['result']> {
    const defaultValues = {
        infoRatings: [],
        count: 0,
        rate: null,
        reviews: [],
        total: 0,
    }
    try {
        const { limit, hotelId, page } = params;
        const url = `/hotel/hotel-tripadvisor-reviews?hotelId=${hotelId}&limit=${limit}&page=${page}`;
        const response: AxiosResponse<HotelReviewsResult> = await axios({
            url,
            method: 'GET',
        });
        if (response.data.success) {
            return response.data.result;
        }
        return defaultValues;
    } catch {
        return defaultValues;
    }
}